import React, { Fragment, useEffect, useState } from 'react';
import { ConfirmDialog } from '@components/dialogs/ConfirmDialog';
import { TextField } from '@components/form-components';
import { useTranslation } from 'react-i18next';
import { IWithdrawFromCompetitionDialog } from './interfaces';

export const WithdrawFromCompetitionDialog: React.FC<
  IWithdrawFromCompetitionDialog
> = ({
  show,
  competitionTitle,
  isPending,
  onClose,
  onConfirm,
}): JSX.Element => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (!show) {
      setReason('');
    }
  }, [show]);

  const handleConfirm = (): void => {
    if (isPending) {
      return;
    }

    onConfirm(reason);
  };

  return (
    <ConfirmDialog
      show={show}
      title={t('competitions:portal.dialogs.withdraw.title')}
      subTitle={t('competitions:portal.dialogs.withdraw.subTitle', {
        title: competitionTitle,
      })}
      onClose={() => {
        if (!isPending) {
          onClose();
        }
      }}
      onConfirm={handleConfirm}
      confirmLabel={t('competitions:portal.dialogs.withdraw.buttons.confirm')}
      confirmVariant="danger"
      disabled={isPending}
    >
      <Fragment>
        <p>{t('competitions:portal.dialogs.withdraw.body')}</p>
        <TextField
          label={t('competitions:portal.dialogs.withdraw.fields.reason')}
          placeholder={t(
            'competitions:portal.dialogs.withdraw.fields.reasonPlaceholder'
          )}
          value={reason}
          onChange={setReason}
          multiline
          disabled={isPending}
        />
      </Fragment>
    </ConfirmDialog>
  );
};
